import type { EmptyInitialValue } from "@octopusdeploy/step-inputs";

export const emptyInitialValue: EmptyInitialValue = Symbol();
